import { render } from "./DocumentLine.vue?vue&type=template&id=3addaba3&scoped=true&ts=true"
import script from "./DocumentLine.vue?vue&type=script&lang=ts"
export * from "./DocumentLine.vue?vue&type=script&lang=ts"

import "./DocumentLine.vue?vue&type=style&index=0&id=3addaba3&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3addaba3"]])

export default __exports__